import React from 'react';

import { CreateClientContext } from './CreateClientContext';
import { EditClientContext } from './EditClientContext';

const useCreateClientContext = () => React.useContext(CreateClientContext);
const useEditClientContext = () => React.useContext(EditClientContext);

export { useCreateClientContext, useEditClientContext };
